import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    inputTextField: {
        width: "324px",
    },
}));
